<template>
	<div id="app">
		<keep-alive
			v-if="!$route.meta.notKeepHeader && $route.fullPath !== '/'"
		>
			<my-header></my-header>
		</keep-alive>
		<keep-alive>
			<router-view
				v-wechat-title="$route.meta.title"
				v-if="$route.meta.keepAlive"
				:key="$route.fullPath"
			></router-view>
		</keep-alive>
		<router-view
			v-wechat-title="$route.meta.title"
			v-if="!$route.meta.keepAlive"
			:key="$route.fullPath"
		></router-view>
	</div>
</template>
<script>
import { getRemembranceMode } from "./http/module/interface";
import header from "@/components/common/header";
export default {
	name: "App",
	provide() {
		return {
			app: this,
		};
	},
	components: {
		"my-header": header,
	},
	data() {
		return {
			isRouterAlive: true,
		};
	},
	created() {
		var vm = this;
		// // * 查询是否开启缅怀模式
		vm.getRemembranceMode();
	},
	methods: {
		getRemembranceMode() {
			let vm = this;
			getRemembranceMode().then((res) => {
				if (res.status === 1) {
					// * 1置灰，2不置灰
					if (res.data == "1") {
						// console.log('开启缅怀模式')
						document
							.querySelector("body")
							.setAttribute("style", "filter: grayscale(100%)");
						document
							.querySelector("body")
							.setAttribute(
								"style",
								"-webkit-filter:grayscale(100%)"
							);
					}
				} else {
					vm.$notify({ type: "danger", message: res.msg });
				}
			});
		},
	},
};
</script>
<style lang="scss">
.van-list__finished-text {
	display: block;
	margin: 0 auto;
	font-weight: 400;
}
</style>
<style lang="scss">
#app {
	width: 100%;
	min-height: 100vh;
	overflow: hidden;
	font-size: 28px;
	background: url(./assets/img/home/page_bgi.png) center center / 100% 100%
		repeat;
}

/* 自定义颜色 */
#nprogress .bar {
	background-color: $base-color !important;
}

.demo-enter-active,
.demo-leave-active {
	transition: 0.3s ease-out;
}

.demo-enter {
	opacity: 0;
}

.demo-leave-to {
	opacity: 0;
}
.rich_text {
	font-size: 30px;
	line-height: 48px;
	img {
		margin: 10px auto;
		height: auto;
		// display: block;
		// width: 100%;
	}
}
.danhang {
	overflow: hidden;
	/*超出部分隐藏*/
	white-space: nowrap;
	/*禁止换行*/
	text-overflow: ellipsis;
	/*省略号*/
}

.duohang2 {
	display: -webkit-box;
	/* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
	-webkit-box-orient: vertical;
	/* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
	text-overflow: ellipsis;
	/* 可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
	-webkit-line-clamp: 2;
	overflow: hidden;
}

.duohang3 {
	display: -webkit-box;
	/* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
	-webkit-box-orient: vertical;
	/* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
	text-overflow: ellipsis;
	/* 可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
	-webkit-line-clamp: 3;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue